import React, { useState, useEffect, useMemo } from "react";
import { Link, useNavigate, useLocation, useParams } from "react-router-dom";

// Languages
import { useTranslation } from "react-i18next";

// Components
import LanguageSelector from "../../LanguageSelector/languageselector";
import CurrencySelector from "../../CurrencySelector/currencyselector";
import RouteLocationDisplayer from "./subComponents/routeLocationDisplayer";

// CSS
import "./uppernavbarclient.css";

// Images
import ProfileIcon from "../../../assets/images/navbar/profile.png";
import { HOTELSRIVER_OFFICIAL_LOGO_URL as Logo } from "../../../utils/hotelsRiverBrandLogo";

// Services
import { getUserDetails } from "../../../services/authService";
import { ROUTES } from "../../../Routes/Routes";
import Tooltip from "@mui/material/Tooltip";
import { getUserInfo } from "../../../services/localStorage";
import { useAppContext } from "../../../contexts/AppContext";
import CurrencyRatesBar from "../../CurrencyRatesBar/CurrencyRatesBar";
import { UserOutlined } from "@ant-design/icons";
import { normalizeAgentImageValue } from "../../../utils/resolveAgentCompanyLogoUrl";

const UpperNavBarClient = ({ hotelName = "", agentId: propAgentId }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const { companylogobase65 } = getUserInfo() || {};
  const clientNavbarLogo = useMemo(
    () => normalizeAgentImageValue(companylogobase65) || Logo,
    [companylogobase65]
  );
  const { currencyRate } = useAppContext();

  // States
  const [isOpen, setIsOpen] = useState(false);
  const [isAgentOnOwnSite, setIsAgentOnOwnSite] = useState(false);
  
  // Check if logged-in agent is viewing their own mini site
  useEffect(() => {
    const currentUser = getUserDetails();
    const isAgentMiniSite = location.pathname.includes(`/${ROUTES.AGENT_MINI_SITE}/`);
    
    // Get agentId from prop (if passed from AgentMiniSite) or from params
    const urlAgentId = propAgentId || params.agentId;
    
    if (currentUser && urlAgentId && isAgentMiniSite) {
      // Normalize both to strings and compare
      const loggedInAgentId = String(currentUser.id || '').trim();
      const agentIdToCompare = String(urlAgentId || '').trim();
      
      // Also check if user is an agent
      const isAgent = currentUser.usertype === "agents" || currentUser.usertype === "agent";
      
      // Debug logging
      console.log('UpperNavBarClient - Agent check:', {
        loggedInAgentId,
        agentIdToCompare,
        match: loggedInAgentId === agentIdToCompare,
        isAgent,
        isAgentMiniSite,
        currentUser: {
          id: currentUser.id,
          usertype: currentUser.usertype,
          email: currentUser.email
        }
      });
      
      setIsAgentOnOwnSite(isAgent && loggedInAgentId === agentIdToCompare && loggedInAgentId !== '');
    } else {
      console.log('UpperNavBarClient - Not showing bar:', {
        hasUser: !!currentUser,
        hasAgentId: !!urlAgentId,
        isAgentMiniSite,
        usertype: currentUser?.usertype
      });
      setIsAgentOnOwnSite(false);
    }
  }, [location.pathname, params.agentId, propAgentId]);

  // Routes with bottom navbar - needs to be updated with every new route
  const pathsWithBottomNav = ["hotelprofile"];

  // Add css to spcific routes
  useEffect(() => {
    const currentPath = window.location.pathname.split("/")[1];

    for (let path of pathsWithBottomNav) {
      if (path === currentPath) {
        // Add css class
        document
          .getElementById("upper-nav-bar")
          .classList.add("upper-nav-bar-with-bottom-nav");
        document
          .getElementById("upper-nav-bar-client")
          .classList.add("upper-nav-bar-client-with-bottom-nav");
      }
    }
  }, []);

  return (
    <div id="upper-nav-bar" className="upper-nav-bar">
      {/* Agent logged-in indicator bar */}
      {isAgentOnOwnSite && (
        <div className="agent-logged-in-bar">
          <div className="agent-logged-in-content">
            <UserOutlined className="agent-icon" />
            <span className="agent-logged-in-text">אתה מחובר כסוכן באתר הבית שלך</span>
            <button 
              className="agent-dashboard-link"
              onClick={() => navigate("/p/dashboard/home")}
            >
              מעבר לדשבורד
            </button>
          </div>
        </div>
      )}
      <div className="upper-nav-bar-client-wrapper">
        <div id="upper-nav-bar-client" className="upper-nav-bar-client">
          <button
            className="dropdown-toggle"
            onClick={() => {
              if (getUserDetails()) {
                navigate(`/p/dashboard/home`);
              } else {
                navigate(`/login`);
              }
            }}
          >
            <img src={ProfileIcon} alt="acount" className="currency-icon" />
            <span> {t("navbar.account")} </span>
            <span
              className={`arrow-icon arrow-icon-currency ${
                isOpen ? "arrow-icon-up" : "arrow-icon-down"
              }`}
            ></span>
          </button>

          {/*<div>*/}
          {/*  <CurrencySelector />*/}
          {/*</div>*/}

          <div>
            <LanguageSelector />
          </div>

          {getUserDetails() && currencyRate && (
            <div className="navbar-item-wrapper-client currency-rates-client tw-hidden lg:tw-block">
              <CurrencyRatesBar currencyRate={currencyRate} compact />
            </div>
          )}
        </div>
        <div className="client-navbar-logo-wrapper">
          <Tooltip title={"לחץ למעבר לעמוד הראשי"}>
            <img
              className="client-navbar-logo-img"
              src={clientNavbarLogo}
              alt="Hotels River Logo"
              width={180}
              height={48}
              decoding="async"
              style={{ cursor: "pointer" }}
              onClick={() => navigate(`/p/dashboard/home`)}
            />
          </Tooltip>
        </div>
      </div>
      <RouteLocationDisplayer hotelName={hotelName} />
    </div>
  );
};

export default UpperNavBarClient;
